import { StickerCard } from "@/components/sticker-card/StickerCard.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import {
  ApiApprovalRequestStatus,
  getRequestStatusTitle,
} from "@/types/approvals/approval.types.ts";
import { ApiTimeOffLogFull } from "@/types/time-off/time-off.types.ts";
import { Button, ButtonLink, FullScreenPage, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface TimeOffRequestFinalProps {
  timeOffLogFull?: ApiTimeOffLogFull;
  closePage: () => void;
  targetEmployeeId: number | undefined;
}

export function TimeOffRequestFinal({
  timeOffLogFull,
  closePage,
  targetEmployeeId,
}: TimeOffRequestFinalProps) {
  const { t } = useTranslation();
  const { renderShortPeriod } = useFormatter();

  return (
    <FullScreenPage isCenterVertical={true} contentSize={"md"}>
      <Stack direction={"horizontal"} items={"center"}>
        <StickerCard
          title={renderShortPeriod(
            timeOffLogFull?.time_off_log.date_from ?? new Date(),
            timeOffLogFull?.time_off_log.date_to ?? new Date()
          )}
          caption={timeOffLogFull?.time_off_log.category.title}
          emoji={timeOffLogFull?.time_off_log.category.emoji || undefined}
          status={getRequestStatusTitle(
            timeOffLogFull?.approval_request_details?.status ?? ApiApprovalRequestStatus.awaiting
          )}
          contentSlot={
            <>
              {timeOffLogFull?.approval_request_details?.status ==
              ApiApprovalRequestStatus.awaiting ? (
                t("time_off:awaiting_approval", {
                  from_count: t("plurals:from_people", {
                    count: timeOffLogFull?.approval_request_details?.confirmations
                      ? timeOffLogFull.approval_request_details.confirmations.length
                      : 0,
                  }),
                })
              ) : (
                <></>
              )}
            </>
          }
        />

        <Stack className={"pl-18"} gap={"lg"}>
          {timeOffLogFull?.approval_request_details?.status == ApiApprovalRequestStatus.awaiting ? (
            <Title
              size={"lg"}
              header={t("time_off:save_final_await_title")}
              caption={t("time_off:save_final_await_caption")}
            ></Title>
          ) : (
            <Title
              size={"lg"}
              header={t("time_off:save_final_approved_title")}
              caption={t("time_off:save_final_approved_caption")}
            ></Title>
          )}

          <Stack direction={"horizontal"} gap={"sm"}>
            <Button onClick={closePage} size={"lg"}>
              {t("common:done")}
            </Button>
            <ButtonLink
              variant="secondary"
              size={"lg"}
              href={`/employees/${targetEmployeeId}/time-off-history`}
            >
              {t("time_off:see_requests")}
            </ButtonLink>
          </Stack>
        </Stack>
      </Stack>
    </FullScreenPage>
  );
}
